import api from '../api/client';

export type SsoLogStatus = 'success' | 'failed' | 'abandoned' | 'in_progress';
export type SsoLogStatusFilter = SsoLogStatus | 'unsuccessful';
export type SsoLogSortBy = 'lastAt' | 'customer';
export type SsoLogSortDir = 'asc' | 'desc';
export type SsoLogClient = 'web' | 'mobile' | 'unknown';
export type SsoDeviceForm = 'phone' | 'tablet' | 'computer' | 'unknown';
export type SsoDeviceOs = 'ios' | 'android' | 'windows' | 'macos' | 'linux' | 'unknown';
export type SsoFailureReason =
  | 'none'
  | 'idp_error'
  | 'callback_error'
  | 'initiate_error'
  | 'app_no_exchange'
  | 'abandoned_at_idp'
  | 'abandoned_after_callback'
  | 'unknown_error';

export interface SsoLogFlow {
  flowId: string | null;
  customerId: number | null;
  customerName: string | null;
  organizationId: number | null;
  organizationName: string | null;
  email: string | null;
  userId: number | null;
  userName: string | null;
  client: SsoLogClient;
  deviceForm: SsoDeviceForm;
  deviceOs: SsoDeviceOs;
  provider: string | null;
  startedAt: string;
  lastAt: string;
  status: SsoLogStatus;
  reason: SsoFailureReason;
  errorMessage: string | null;
  steps: string[];
  userAgent: string | null;
  receivedLoginHint: string | null;
  sentLoginHint: string | null;
  loginHintForwarded: boolean;
  forwardingDisabled: boolean;
  userRsid: string | null;
}

export interface SsoLogStep {
  id: number;
  step: string;
  client: string | null;
  email: string | null;
  success: boolean;
  errorMessage: string | null;
  outcome: string | null;
  userAgent: string | null;
  createdAt: string;
}

export interface SsoLogListResult {
  items: SsoLogFlow[];
  total: number;
  summary: Record<SsoLogStatus, number>;
  organizations: Array<{ id: number; name: string }>;
}

export interface SsoLogQuery {
  days?: number;
  organizationId?: number;
  email?: string;
  client?: SsoLogClient | '';
  device?: SsoDeviceForm | '';
  status?: SsoLogStatusFilter;
  sortBy?: SsoLogSortBy;
  sortDir?: SsoLogSortDir;
  limit?: number;
  offset?: number;
}

export const ssoLogService = {
  async list(params: SsoLogQuery): Promise<SsoLogListResult> {
    const res = await api.get('/api/sysadmin/sso-log', {
      params: {
        days: params.days,
        organizationId: params.organizationId || undefined,
        email: params.email || undefined,
        client: params.client || undefined,
        device: params.device || undefined,
        status: params.status,
        sortBy: params.sortBy,
        sortDir: params.sortDir,
        limit: params.limit,
        offset: params.offset,
      },
    });
    return res.data.data;
  },

  async getSteps(flowId: string): Promise<SsoLogStep[]> {
    const res = await api.get(`/api/sysadmin/sso-log/${encodeURIComponent(flowId)}`);
    return res.data.data.steps;
  },
};
